(() => {
  const rootSelector = '[data-product-feature-reveal]';

  if (window.GmProductFeatureReveal) {
    window.GmProductFeatureReveal.initAll();
    return;
  }

  const controllers = new Map();
  const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  const initRoot = (root) => {
    if (!root || controllers.has(root)) return;

    const items = Array.from(root.querySelectorAll('[data-product-feature-reveal-item]'));
    if (!items.length || prefersReducedMotion() || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -80px 0px',
        threshold: 0.12
      }
    );

    const revealLine = window.innerHeight - Math.min(80, window.innerHeight * 0.1);

    items.forEach((item) => {
      const bounds = item.getBoundingClientRect();

      if (bounds.top < revealLine && bounds.bottom > 0) {
        item.classList.add('is-visible');
        return;
      }

      observer.observe(item);
    });

    root.classList.add('is-reveal-ready');

    controllers.set(root, {
      cleanup() {
        observer.disconnect();
        root.classList.remove('is-reveal-ready');
        items.forEach((item) => item.classList.remove('is-visible'));
      }
    });
  };

  const destroyRoot = (root) => {
    const controller = controllers.get(root);
    if (!controller) return;

    controller.cleanup();
    controllers.delete(root);
  };

  const initAll = (scope = document) => {
    const roots = scope.matches?.(rootSelector) ? [scope] : Array.from(scope.querySelectorAll(rootSelector));
    roots.forEach(initRoot);
  };

  const destroyAll = (scope = document) => {
    const roots = scope.matches?.(rootSelector) ? [scope] : Array.from(scope.querySelectorAll(rootSelector));
    roots.forEach(destroyRoot);
  };

  window.GmProductFeatureReveal = { initAll, destroyAll };

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyAll(event.target));
})();
